//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapState } from 'vuex';
import ChatModal from './ChatModal.vue';
import FeedbackModal from './FeedbackModal.vue';
import constant from '~/const';
import User from '~/components/User.vue';

export default {
  components: {
    ChatModal,
    FeedbackModal,
    User,
  },

  props: {
    data: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      chat: {
        show: false,
        step: 0,
      },
      feedback: {
        show: false,
      },
      constant,
    };
  },

  computed: {
    ...mapGetters('currencies', ['toCurrencyFormat']),
    ...mapGetters('p2pDeals', ['sortedByDateChatMessages']),
    ...mapState('p2pDeals', {
      chatMessages: 'chatMessages',
      feedbackMessages: 'feedback',
    }),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralProgress',
      'setErrorNotification',
      'setSuccessNotification',
      'confirmAction',
    ]),
    ...mapActions('p2pDeals', [
      'getChatMessages',
      'getFeedback',
      'deleteFeedback',
      'editFeedback',
    ]),

    deleteFeedbackMessage(message) {
      const { id } = message;
      this.confirmAction({
        text: 'Are you sure you want to delete feedback?',
        callback: async () => {
          this.setGeneralProgress(true);
          await this.deleteFeedback(id);
          await this.getFeedback({
            tradeId: this.data.id,
            limit: 50,
          });
          this.setGeneralProgress(false);
          this.setSuccessNotification('Feedback deleted');
        },
      });
    },

    async showFeedback() {
      const { id } = this.data;

      this.setGeneralProgress(true);
      await this.getFeedback({
        tradeId: id,
        limit: 50,
      });
      this.setGeneralProgress(false);
      this.feedback.show = true;
    },

    async applyEditFeedback({ comment, influence, feedbackId }) {
      this.setGeneralProgress(true);
      this.editingFeedback.loader = true;
      await this.editFeedback({ comment, influence, feedbackId });
      await this.getFeedback({ tradeId: this.data.id, limit: 50 });
      this.editingFeedback.modal = false;
      this.setGeneralProgress(false);
      this.editingFeedback.loader = false;
      this.setSuccessNotification('Feedback edited');
    },

    async showChat(params, step) {
      this.setGeneralProgress(true);
      try {
        await this.getChatMessages({
          ...params,
          limit: 1000,
        });
        this.chat.show = true;
        if (step) {
          this.chat.step = step;
        }
      } catch (error) {
        this.setErrorNotification('Trade chat does not exist');
      }
      this.setGeneralProgress(false);
    },
  },
};
